import React from 'react';

import {EDITORIAL, PODCAST} from 'src/routes/paths';
import {ChiefLogo} from 'src/svgs/chiefLogo';

import {SanityEditorial} from 'types/generated';

type SponsoredArticleProps = {
  sponsoredArticle: SanityEditorial;
};

export const SponsoredArticleBannerInline: React.FC<SponsoredArticleProps> = (props: SponsoredArticleProps) => {
  return (
    <div
      className="bg-green-dark md:text-center col-span-full flex flex-wrap my-10 ml-[calc(-50vw+50%)] w-screen md:w-full md:ml-0"
      data-module="sponsorship-banner-inline"
    >
      <div className="w-full md:w-1/3 relative">
        <div className="md:absolute w-full h-[220px] md:h-full">
          {props.sponsoredArticle.sponsorship?.sponsorshipImagePortrait?.asset?.url ? (
            <img
              className="object-cover w-full h-full"
              src={props.sponsoredArticle.sponsorship.sponsorshipImagePortrait?.asset?.url}
              alt={
                props.sponsoredArticle.sponsorship.sponsorshipImagePortrait.altText ||
                props.sponsoredArticle.sponsorship.sponsorshipImagePortrait.asset?.filename
              }
            />
          ) : (
            <div className="w-full h-full object-cover bg-black flex items-center justify-center">
              <ChiefLogo classes={'mb-2 lg:mb-0 h-[18px] lg:w-25 lg:h-[8%] fill-light-gold'} />
            </div>
          )}
        </div>
      </div>

      <div className="w-full md:w-2/3 md:p-16 m-auto mb-10 md:mb-0 mt-6 md:mt-0 px-gutter">
        <div className="flex flex-wrap items-center md:justify-center mb-4 md:mb-5">
          <span className="type-lota mx-2 text-light-gold mb-2 inline">
            {props.sponsoredArticle.sponsorship?.sponsoredText || 'In Sponsorship with'}
          </span>
          {props.sponsoredArticle.sponsorship?.clientLogo?.asset ? (
            <img
              className="h-6 fill-white !mt-0 !mb-2"
              src={props.sponsoredArticle.sponsorship?.clientLogo?.asset?.url || ''}
            />
          ) : (
            <span className="type-lota text-light-gold">{props.sponsoredArticle?.sponsorship?.clientName}</span>
          )}
        </div>

        <a
          href={`${props.sponsoredArticle.isPodcast ? PODCAST : EDITORIAL}/${props.sponsoredArticle.slug?.current}`}
          className="transition-all ease-out hover:ease-in duration-500 cursor-pointer underline !decoration-transparent hover:!decoration-white"
        >
          <h3 className="type-delta md:type-theta !text-white">{props.sponsoredArticle.title}</h3>
        </a>
      </div>
    </div>
  );
};
